import React from "react";
import { BrowserRouter as Router, Route, Switch, Redirect} from 'react-router-dom';

import Home from './components/home-page/home/home';
// import FlipBook from './components/flipbook/flipbook';
import ClinicNavbar from './components/clinic-system/clinicnavbar/clinicnavbar'

import Navigationbar from './components/home-page/navigationbar/navigationbar';
import Footer from './components/home-page/footer/footer';
import './App.css';
import ReactGA from 'react-ga';

import Login from './components/home-page/login/login';
import ForgotPassword from './components/home-page/forgot-password/forgot-password';
import RegisterClinic from './components/register-forms/register-clinic/register-clinic';
import ResetPassword from './components/home-page/forgot-password/reset-password.js/reset-password';

import WorkInProgress from './components/work-in-progress/work-in-progress';

// import GetPosition from './components/get-position/get-position';

import AboutUs from './components/home-page/links/company/about-us/about-us';
import SuperPractice from './components/home-page/links/for-dentists/super-practice/super-practice';
import PatientAcquasition from "./components/home-page/links/for-dentists/patient-acquisition/patient-acquisition";
import Careers from './components/home-page/links/company/careers/careers';
import Referrals from './components/home-page/links/company/referrals/referrals';

import OneEmirate from './components/display-clinics/one-emirate/one-emirate';
import OneClinic from './components/display-clinics/one-clinic/one-clinic';
import OneDentist from './components/display-clinics/one-dentist/one-dentist';


import NearMe from './components/home-page/near-me/near-me';

import ChangePrices from './components/clinic-system/change-prices/change-prices';
import ClinicProfile from './components/clinic-system/clinic-profile/clinic-profile'
import Staff from './components/clinic-system/staff/staff'
import ImagesMedia from './components/clinic-system/images-media/images-media'
import Account from './components/clinic-system/account/account'
import Calendar from './components/clinic-system/calendar/calendar';
import Bookings from './components/clinic-system/bookings/bookings';
import OpeningHours from './components/clinic-system/opening-hours/opening-hours';
import UpdateDentist from './components/clinic-system/staff/amend/update/update'
import Campaigns from './components/clinic-system/campaigns/campaigns';
import ViewClinic from './components/clinic-system/view-clinic/view-clinic';
import ClinicViewDentist from './components/clinic-system/view-clinic/clinic-view-dentist/clinic-view-dentist';

import RegisterUser from './components/booking/register/register';
import ReviewBooking from './components/booking/review/review';
import ReviewVisit from './components/home-page/review/review';

import VerifyEmail from './components/clinic-system/verify-email/verify-email';



function App() {

  ReactGA.initialize('UA-152034230-1');
  ReactGA.pageview(window.location.pathname + window.location.search);

  const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route {...rest} render={(props) => (
      localStorage.getItem('token')
        ? <Component {...props} />
        : <Redirect to='/login' />
    )} />
  )


  return (
    <Router>
      <Switch>

      <PrivateRoute path="/logged-in" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/add-dentist" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/calendar" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/services" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/clinic-profile" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/staff/update" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/staff" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/images-media" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/account" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/bookings" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/opening-hours" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/campaigns" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/view-clinic" component={ClinicNavbar}/>
      <PrivateRoute path="/logged-in/dentists/:dentist/" component={ClinicNavbar}/>

      <Route path="/reset-password/:token/:_id" component={Navigationbar}/>
      <Route path="/review-visit/:token/:_id" component={Navigationbar}/>
      <Route path="/forgot-password" component={Navigationbar}/>
      <Route path="/booking/review" component={Navigationbar}/>
      <Route path="/booking/register" component={Navigationbar}/>
      <Route path="/verify-email/:token/:_id" component={Navigationbar}/>
      <Route path="/for-dentists/patient-acquisition" component={Navigationbar}/>
      <Route path="/for-dentists/super-practice" component={Navigationbar}/>
      <Route path="/about-us" component={Navigationbar}/>
      <Route path="/careers" component={Navigationbar}/>
      <Route path="/support" component={Navigationbar}/>
      {/* <Route path="/add-clinic" component={Navigationbar}/> */}
      <Route path="/referrals" component={Navigationbar}/>
      <Route path="/sitemap" component={Navigationbar}/>
      <Route path="/calendar" component={Navigationbar}/>
      {/* <Route path="/join-today" component={Navigationbar}/> */}
      <Route path="/login" component={Navigationbar}/>
      <Route path="/clinics/:emirate" component={Navigationbar}/>
      <Route path="/clinic/:clinic" component={Navigationbar}/>
      <Route path="/near-me" component={Navigationbar}/>
      {/* <Route path="/testing" component={Navigationbar}/> */}
      <Route path="/dentists/:dentist" component={Navigationbar}/>
      <Route path="/register" component={Navigationbar}/>


      </Switch>

      <Route exact={true} path="/" render={() => (
        <>
          <Navigationbar/>
          <Home/>
          {/* <GetPosition/> */}
        </>
      )}/>

      <Switch>

        <Route path="/for-dentists/patient-acquisition" component={PatientAcquasition}/>
        <Route path="/for-dentists/super-practice" component={SuperPractice}/>
        <Route path="/about-us" component={AboutUs}/>
        <Route path="/careers" component={Careers}/>
        <Route path="/referrals" component={Referrals}/>
        <Route path="/support" component={WorkInProgress}/>
        <Route path="/sitemap" component={WorkInProgress}/>
        
        
        <Route path="/forgot-password" component={ForgotPassword}/>
        <Route path="/booking/register" component={RegisterUser}/>
        <Route path="/booking/review" component={ReviewBooking}/>

        <Route path="/calendar" component={Calendar}/>
        <Route path="/login" component={Login}/>
        <Route path="/register" component={RegisterClinic}/>

        <Route path="/clinics/:emirate" component={OneEmirate}/>
        <Route path="/clinic/:clinic" component={OneClinic}/>
        <Route path="/dentists/:dentist" component={OneDentist}/>
        <Route path="/near-me" component={NearMe}/>
        {/* <Route path="/testing" component={Testing}/> */}

        <Route path="/verify-email/:token/:_id" component={VerifyEmail}/>
        <Route path="/reset-password/:token/:_id" component={ResetPassword}/>
        <Route path="/review-visit/:token/:_id" component={ReviewVisit}/>

        <PrivateRoute path="/logged-in/clinic-profile" component={ClinicProfile}/>
        <PrivateRoute path="/logged-in/staff/update" component={UpdateDentist}/>
        <PrivateRoute path="/logged-in/staff" component={Staff}/>
        <PrivateRoute path="/logged-in/images-media" component={ImagesMedia}/>
        <PrivateRoute path="/logged-in/account" component={Account}/>
        <PrivateRoute path="/logged-in/campaigns" component={Campaigns}/>
        <PrivateRoute path="/logged-in/services" component={ChangePrices}/>
        <PrivateRoute path="/logged-in/calendar" component={Calendar}/>
        <PrivateRoute path="/logged-in/bookings" component={Bookings}/>
        <PrivateRoute path="/logged-in/opening-hours" component={OpeningHours}/>
        <PrivateRoute path="/logged-in/view-clinic" component={ViewClinic}/>
        <PrivateRoute path="/logged-in/dentists/:dentist/" component={ClinicViewDentist}/>
        {/* <PrivateRoute path="/logged-in/change-prices/:clinic_id" component={ChangePrices}/> */}


      </Switch>
      <Footer/>
    </Router>


  );
}

export default App;
